import {useStore} from "vuex";


export default class ActionStringNormalize{
    static $names = {
        'name': 'სახელი',
        'map_x':'გრძედი',
        'map_y':'განედი',
        'roomid':'ოთახის-ID',
        'id': 'ID',
        'sensorid':'სენსორის-ID',
        'value1': 'განგაშის ტიპი',
        'value2': 'ლიმიტი',
        'value3': 'დრო',
        'value4':'ინდექსი',
        'sound':'ხმა',
        'firmaid':'ფირმის-ID',
        'isactive':'აქტიური',
        'alertstypeid':'ალერტის ტიპი',
        'popup':'პოპაპ ფანჯარა',
        'allusers':'ყველა მომხმარებელი',
        'defaultsms':'სმს',
        'defaultemail':'ელ.ფოსტა',
        'image':'რუკა'

    }

    static normalized(key){
        return Object.prototype.hasOwnProperty.call(this.$names, key) ? this.$names[key] : key
    }

    static valueTryLinking(element,linker, tablename){
        let state = useStore().state

        if (tablename === "tempohub_roomsensors") {
            // if we have roomid attach room name
            if (Object.prototype.hasOwnProperty.call(element, 'roomid')) {
                //find room into state rooms we fetched rooms in dashboard
               let room = state.warehouse.rooms.data.list.filter(e => e.id === linker)[0]
                if (typeof room !== "undefined") {
                    return "ოთახი: " + room.name
                }
            }
        }
        if (linker === null){
            return "ცარიელი"
        }

        if (typeof linker === "boolean"){
            if (linker) return "დიახ"
            if (!linker) return "არა"
        }
        return linker
    }
}